import React from 'react'
import { Button } from '@fs/zion-ui'
import { TreePedigree } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'
import { useGroupsContext } from '@fs/zion-tree-groups'
import { useStartingPerson } from '../../../providers/StartingPersonProvider'
import { useMembersContext } from '../../../providers/MembersProvider'

export default function ViewResearcherTreeButton({ showMobileText, viewTreeUrl }) {
  const { treeDetails } = useGroupsContext()
  const { startingPersonId, startingPersonDeleted, deletedStartingPersonOverlay } = useStartingPerson()
  const [t] = useTranslation()
  const { userIsAdmin } = useMembersContext()
  const isDisabled = (!startingPersonId && !userIsAdmin) || !treeDetails || treeDetails?.hidden
  const label = showMobileText
    ? t('group-management.group-tree-mobile.action')
    : t('group-management.researcher-tree.label')

  if (startingPersonDeleted) {
    return (
      <Button
        fullWidth
        data-testid="member-actions.researcher-tree.button"
        emphasis="medium"
        linkName="Group Info: View Tree: ReT"
        onClick={deletedStartingPersonOverlay.handleClick}
        Icon={TreePedigree}
        disabled={isDisabled}
      >
        {label}
      </Button>
    )
  }

  return (
    <Button
      fullWidth
      data-testid="member-actions.researcher-tree.button"
      emphasis="medium"
      linkName="Group Info: View Tree: ReT"
      to={!isDisabled ? viewTreeUrl : '#'}
      external
      Icon={TreePedigree}
      disabled={isDisabled}
    >
      {label}
    </Button>
  )
}
